const articleTypes = {
	EBOOK: "ebook",
	PODCAST: "podcast",
	AUDIOBOOK: "audiobook",
};

export default articleTypes;
